module.exports = require("@babel/runtime/core-js/reflect/define-metadata");